import getRequestOptions from "../utils/getRequestOptions";
import IGetItem from "../interfaces/IGetItem";

const useGetItem = () => {

    /** Get item - return single item by id
     * @param {URL} url - api endpoint url f.e. 'https://example.com/api/v1/users'
     * @param {string} [options.accessToken] - Access token is added to Authentication header if defined
     * @param {AbortSignal} [options.abortSignal] - signal to abort the 
     **/
    const getItem = async (url:URL, options?: IGetItem) => {
        try {

            const requestOptions = getRequestOptions({ method: "GET", ...options });

            const response = await fetch(url, requestOptions);

            let data = null;

            // Try to Parse JSON data from the response
            try {
                data = await response.json();
            } catch (err) {
                data = [];
            }

            // Return an object containing both the raw response and the parsed data
            const resObj = {
                statusText: response.statusText,
                status: response.status,
                ok: response.ok,
                url: response.url,
                data: data,
            };

            // Throw error if result is not ok
            if (!response.ok) throw resObj;

            return resObj;

        } catch (error: any) {
            if (error.name === 'AbortError') {
                return { requestAborted: true, ...error }
            } else {
                throw error;
            }
        }

    }

    return getItem;

}

export default useGetItem;
